export default "__VITE_ASSET__CVUpBkI7__"